module.exports = __webpack_public_path__ + "static/img/banner2.09ee536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner2.png
// module id = IB43
// module chunks = 1